import { lazy } from 'react';
import { RouterRoute } from '../../../router/router.types';
import KioskAuthAppPaths from './KioskAuth.paths';

const KioskAuthPage = lazy(() => import('../../../pages/KioskAuth/KioskAuthPageWrapper'));

const kioskAuthRoutes: RouterRoute<KioskAuthAppPaths>[] = [
  {
    path: KioskAuthAppPaths.Login,
    element: KioskAuthPage,
    isLazy: true,
    isProtected: false,
  },
];

export default kioskAuthRoutes;
